<h3><a ng-click="viewDetails($event, item)">{{itemTitle}} </a></h3>
<ul class="workflow-property-list">
    <li>{{item.Workflow.UniqueRegistrationNumber}}</li>
    <li>{{categoryName|localize}}</li>
    <li>{{stageName|localize}}</li>
    <li>{{'workflowPropertyList.validFrom'|translate}} {{ValidFrom|cDate}}</li>
    <li ng-if="isValidDate">{{'workflowPropertyList.validUntil'|translate}} {{item.Workflow.ValidUntil|cDate}} </li>
</ul>
